/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "4c4c78cba806e08d51039e8646d0d66f1e82d2cc";
